import React from 'react';
import { Header } from 'semantic-ui-react';

import CreatePermissionSetForm from './CreatePermissionSetForm';

const CreatePermissionSet = (props) => {
  return (
    <React.Fragment>
      <Header as="h2">
        New Permission Set
      </Header>
      <CreatePermissionSetForm />
    </React.Fragment>
  );
};

export default CreatePermissionSet;
